import React from 'react';
import { SvgIconProps } from '@mui/material';
import QuestionMarkRoundedIcon from '@mui/icons-material/QuestionMarkRounded';

export const UnkownConnectorIcon: React.FC<SvgIconProps> = (props) => {
  return <QuestionMarkRoundedIcon {...props} />;
};
